<template>
  <div>
    <transition name="partialloader">
      <div v-if="!context" class="pageloader partial">
        <span class="loading-text">{{loadingText}}</span>
      </div>
    </transition>
    <section v-if="context" class="detail-spot">
      <hero
        :items="context.gallery_images"
        :eyecatch="context.thumb.url"
        :caption="context.caption"
      >
      </hero>
      <div class="container">
        <div class="card has-detail">
          <div class="card-content">
            <header class="card-header">
              <div class="title-wrapper">
                <span class="genre">SPOT DETAIL</span>
                <h2 class="title">
                  {{context.title}}
                </h2>
              </div>

              <audio-player
                v-if="context.audio"
                :playlist="[
                  {
                    title: context.audio.title,
                    artist: '',
                    url: baseUrl + context.audio.file,
                    duration: context.audio.duration
                  },
                ]"
              >
              </audio-player>

            </header>
            <div class="content">
              <stream-field
                :items="context.body"
              ></stream-field>
            </div>

            <div class="utilities">
              <div class="utility-item">
                <share-button
                  :title="context.title"
                  :description="context.summary"
                  :quote="context.summary"
                  hashtags="国立新美術館,NACT,NACTconic"
                >
                </share-button>
              </div>
              <div class="utility-item">
                <text-size-selector
                  :isopen=false
                  :haslabel=false
                  class="is-align-right"
                >
                </text-size-selector>
              </div>
            </div>

            <floor-map
              v-if="context.location_maps && context.location_maps.length > 0"
              :items="context.location_maps"
              :map_id=Number(context.number)
            >
            </floor-map>

            <div v-if="context.information" class="information">
              <stream-field
                :items="context.information"
              ></stream-field>
            </div>

          </div>
        </div>
      </div>

      <div v-if="context.gallery_images && context.gallery_images.length > 0" class="image-gallery">
        <div class="container">
          <header class="aside-header">
            <h3 class="subtitle has-text-left">Photos</h3>
          </header>
          <masonry
            :items="context.gallery_images"
            :spot_id=Number(context.number)
          >
          </masonry>
        </div>
      </div>

      <div v-if="context.keywords" class="keywords">
        <div class="container">
          <div class="l-card">
            <header class="aside-header">
              <h3 class="subtitle has-text-left">Keywords</h3>
            </header>
            <ul>
              <li v-for="keyword in context.keywords" :key="keyword.id" class="tag is-danger">
                <router-link :to="'/keywords/' + keyword.spot_keyword.slug">{{keyword.spot_keyword.keyword}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="scroller">
        <div class="container">
          <header class="aside-header">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">
                  <h2 class="title basic has-text-left"><span class="icon-spots"></span>{{ $t("others_title_main") }}<span class="title-jp">{{ $t("others_title_sub") }}</span></h2>
                </div>
              </div>
            </div>
          </header>
        </div>
        <scroller
          v-if="context.related_spots && context.related_spots.length > 0"
          :items="context.related_spots"
          base_dir="/spots/"
          shape="square"
          image_src="url"
          :total=Number(context.related_spots.length)
        >
        </scroller>
      </div>

    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import Hero from '../components/Hero.vue'
import AudioPlayer from '../components/AudioPlayer.vue'
import TextSizeSelector from '../components/TextSizeSelector.vue'
import StreamField from '../components/StreamField.vue'
import FloorMap from '../components/FloorMap.vue'
import Masonry from '../components/Masonry.vue'
import Scroller from '../components/horizontalScroller.vue'
import ShareButton from '../components/ShareButton.vue'

export default {
  name: 'Spot',
  components: {
    Hero,
    AudioPlayer,
    TextSizeSelector,
    StreamField,
    FloorMap,
    Masonry,
    Scroller,
    ShareButton,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      type: 'spot.SpotPage',
      slug: this.$route.params.slug,
      loadingText: 'Loading',
      guide: {
        steps: [
          {
            target: '.icon-question-circle',
            content: 'guide_button',
            offset: -100,
            duration: 800,
          },
          {
            target: '.bm-burger-button',
            content: 'guide_menu',
            offset: -100,
            duration: 800,
          },
          {
            target: '.hooper-next',
            content: 'guide_photo_slider',
            offset: -100,
            duration: 800,
            params: {
              placement: 'bottom',
            }
          },
          {
            target: '.audioPlayer',
            content: 'guide_audio',
            offset: -100,
            duration: 800,
            params: {
              placement: 'bottom',
            }
          },
          {
            target: '.text-size-selector.is-align-right',
            content: 'guide_textsize',
            offset: -250,
            duration: 800,
            params: {
              placement: 'top',
            }
          },
          {
            target: '.maps',
            content: 'guide_floormap',
            offset: -250,
            duration: 800,
            params: {
              placement: 'bottom',
            }
          },
          {
            target: '.image-gallery .img-wrap',
            content: 'guide_gallery',
            offset: 0,
            duration: 800,
            params: {
              placement: 'bottom',
            }
          },
          {
            target: '.tag',
            content: 'guide_Keywords',
            offset: 0,
            duration: 800,
            params: {
              placement: 'bottom',
            }
          },
          {
            target: '.scroller .scrolling-wrapper',
            content: 'guide_other_spots',
            offset: 0,
            duration: 800,
            params: {
              placement: 'bottom',
            }
          },
          {
            target: '.button-base.is-fixed',
            content: 'guide_back',
            offset: 0,
            duration: 800,
            params: {
              placement: 'top',
            }
          },
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'getAllPages',
      'isPagesLoaded',
      'getSingleContext',
    ]),
    context: function() {
      return this.getSingleContext(this.$route.params.slug)
    },
  },
  watch: {
    $route (){
      // console.log('to', to)
      // console.log('from', from)
      this.getDataFromApi()
    },
  },
  methods: {
    ...mapActions([
      'fetchPageByPath',
      'fetchPageByType',
      'setGuideSteps',
    ]),
    getDataFromApi: function() {
      this.fetchPageByType({ type: this.type, slug: this.$route.params.slug, lang:this.$root.$i18n.locale })
    },
    getKeywordsStrings: function(keywords) {
      return _.map(keywords, 'keyword').join(", ");
    }
  },
  created() {},
  beforeMount() {
    this.getDataFromApi()
  },
  mounted() {
    this.setGuideSteps({ steps: this.guide.steps })
  }
}
</script>
